const hoverAnimation = {
  transition: 'transform 0.3s, box-shadow 0.3s',
  _hover: { transform: 'translateY(-5px)', shadow: 'xl' },
};

export enum ContentCardAnimation {
  hover = 'hover',
}

export const ContentCardAnimationList = {
  [ContentCardAnimation.hover]: hoverAnimation,
};
